import { useEffect, useState } from "react";
import { connect } from "react-redux";
import moment from "moment";

import CustomInputV2 from "../../../common/CustomInputV2";
import CustomButton from "../../../common/CustomButton";
import CustomActionButton from "../../../common/CustomActionButton";
import { UpdateAmbassadorDetails } from '../../../redux/ambassador/actions';
import toast from "react-hot-toast";
import { delay } from "../../../utils";

function EditAmbassadorForm(props) {
    const { user, SlideTo, setShow } = props;
    const [userState, setUserState] = useState();

    const handleChange = (e) => {
        setUserState({ ...userState, [e.target.name]: e.target.value })
    }

    useEffect(() => {
        setUserState({
            first_name: user.first_name,
            last_name: user.last_name,
            email_address: user.email_address,
            dob: user.dob && moment(user.dob).format("YYYY-MM-DD"),
            mobile_number: user.mobile_number,
        })
    }, [user])

    return (
        <div id="ambassador-edit-form">
            <form>
                <div className='euf-form-container'>
                    <div id='euf-form-inputs'>
                        <CustomInputV2 placeholder="first name" value={userState?.first_name} name="first_name" onChange={handleChange} />
                        <CustomInputV2 placeholder="last name" value={userState?.last_name} name="last_name" onChange={handleChange} />
                        <CustomInputV2 placeholder="email" value={userState?.email_address} name="email_address" onChange={handleChange} />
                        <CustomInputV2 type="date" value={userState?.dob} name="dob" onChange={handleChange} />
                        <CustomInputV2 placeholder="mobile No" value={userState?.mobile_number} name="mobile_number" onChange={handleChange} />
                    </div>
                    <div className='euf-action'>
                        <CustomButton isPrimary={false} onClick={() => { SlideTo(0) }}>BACK</CustomButton>
                        <CustomActionButton action={async () => {
                            if (
                                userState.first_name == user.first_name &&
                                userState.last_name == user.last_name &&
                                userState.email_address == user.email_address &&
                                (userState.dob && moment(userState.dob).format("YYYY-MM-DD")) == (user.dob && moment(user.dob).format("YYYY-MM-DD")) &&
                                userState.mobile_number == user.mobile_number
                            ) {
                                toast.error('Nothing to update!');
                                return false;
                            }

                            const res = await props.UpdateAmbassadorDetails(userState, user.id);

                            if (res) {
                                toast.success("Ambassador successfully updated.");
                                delay(() => {
                                    setShow(false);
                                }, 2000);
                                return true;
                            } else {
                                toast.error("Failed to update ambassador!")
                                return false;
                            }
                        }}>UPDATE</CustomActionButton>
                    </div>
                </div>
            </form>
        </div>
    );
}

const mapStateToProps = (state) => ({
})

export default connect(mapStateToProps, {
    UpdateAmbassadorDetails,
})(EditAmbassadorForm);
